import { Component, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Overlay } from '@angular/cdk/overlay';
import * as moment from 'moment';

import { AuthService } from '../auth/auth.service';
import { User } from '../users/user.model';
import { DateFieldComponent } from './date-field.component';
import { HistoryDialogComponent } from './history-dialog.component';

interface History {
  value: string,
  date: string,
  user: {id: string, email: string, first_name: string, last_name: string}
};

@Component({
  selector: 'app-date-history-field',
  templateUrl: './date-history-field.component.html',
  styleUrls: ['./date-history-field.component.scss']
})
export class DateHistoryFieldComponent extends DateFieldComponent {

  history: History[] = [];
  currentUser: User = this.authService.currentUser;
  get valueWithHistory() {
    let values = JSON.parse(JSON.stringify(this.history));
    let lastHistory = values[values.length-1];
    let lastValue = lastHistory != null ? lastHistory.value : null;
    let value = this.value != null && moment(this.value).isValid() ? moment(this.value).format("YYYY-MM-DD") : null;
    if (lastValue !== value) {
      let u = this.currentUser;
      values.push({
        value: value,
        date: +moment(), 
        user: {
          id: u.id,
          email: u.email,
          first_name: u.firstName,
          last_name: u.lastName
        }
      });
    }
    return values;
  }
  
  constructor(
    cd: ChangeDetectorRef,
    overlay: Overlay,
    private authService: AuthService,
    private dialog: MatDialog) { super(cd, overlay); }

  loadValue(draftValue?) {
    this.history = this.templateData instanceof Array ? this.templateData : [];
    let lastValue = this.history[this.history.length-1];
    let value = lastValue != null ? moment(lastValue.value, "YYYY-MM-DD") : moment(this.defaultValue, "YYYY-MM-DD");
    if (value.isValid()) {
      this.value = value;
    }

    if (this.value == null) {
      this.value = this.defaultValue;
    }
  }

  emitValue() {
    this.valueChanged.emit({field: this.id, value: this.valueWithHistory});
    this.checkHighlight();
  }

  resetDirty(defaultValue) {
    this.history = this.valueWithHistory;
    super.resetDirty(defaultValue);
  }

  showHistory() {
    let values = this.history.map((h) => {
      let value = h.value != null && moment(h.value).isValid() ? moment(h.value).format(this.format) : null;
      return {
        value: value,
        date: h.date,
        user: h.user
      }
    })
    let dialogRef = this.dialog.open(HistoryDialogComponent, {
      height: Math.min(window.innerHeight, 320)+"px",
      width: Math.min(window.innerWidth, 480)+"px",
      data: {label: this.label, values: values}
    });
  }

  setPreviousValue(value) {
    if (value instanceof Array) {
      let last = value[value.length-1];
      value = last != null ? last.value : null;
    }
    super.setPreviousValue(value);
  }

}



// WEBPACK FOOTER //
// ./src/app/forms/date-history-field.component.ts